import type {UpdateClientFormPayload} from "./update-client.schema";

import {updateClient} from "@project/sdk/sales";
import {UpdateClientBody} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";

import {clientKeys, clientMutationKeys} from "../../../client-keys";

import {updateClientMapper} from "./update-client.mapper";

export function updateClientMutationOptions(clientId: string) {
  return mutationOptions({
    mutationFn: (payload: UpdateClientFormPayload) =>
      updateClient(clientId, UpdateClientBody.parse(updateClientMapper.toSdk(payload))),
    mutationKey: clientMutationKeys.updateClient,
    onSuccess: async (_result, _payload, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: clientKeys.detail(clientId)}),
        client.invalidateQueries({queryKey: clientKeys.lists()}),
      ]);
    },
  });
}
